import React from 'react';
import { useSelector } from 'react-redux';
import _ from 'lodash';
import Icon from './Icon';
import Title from './Title';
import Summary from './Summary';

export default function Collapsed() {
  const paymentMethod = useSelector(state => state.checkout.paymentMethod);

  return _.isEmpty(paymentMethod) ? (
    <>
      <Icon />
      <Title />
    </>
  ) : (
    <Summary paymentMethod={paymentMethod} />
  );
}
